import { combineEpics, ofType } from 'redux-observable'
import { EMPTY, of } from 'rxjs'
import { catchError, filter, map, switchMap, takeUntil } from 'rxjs/operators'

import { getTimezoneId, getTZOffset } from 'utils/dateUtils'
import { isSimulationAndTraining } from 'utils/plans'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import {
  selectActualCompanyId,
  selectActualLicenses,
  selectHasSelectedCompanyFilterAccess,
} from 'containers/App/selectors'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from '../constants'
import {
  selectDateFilter,
  selectDateRange,
  selectHasIncidentWidgetAccess,
  selectWithoutScanback,
} from '../selectors'

import { spamWidgetRedux } from './redux'

const getSpamWidgetEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      spamWidgetRedux.INITIATE,
      DATE_FILTER_CHANGE,
      SCANBACK_CHANGE
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)

      return true
    }),
    switchMap(() => {
      const state = state$.value
      // INITIATE and company-data success turn the loader on. Cancel so a child
      // the user cannot swap into does not leave the widget spinning.
      if (!selectHasSelectedCompanyFilterAccess(state)) {
        return of(spamWidgetRedux.cancel())
      }
      const licenses = selectActualLicenses(state)
      const hasWidgetAccess = selectHasIncidentWidgetAccess(state)

      if (isSimulationAndTraining(licenses.plan) || !hasWidgetAccess) {
        return EMPTY
      }

      const selectedCompany = state.partnerOptions.selectedCompany?.value
      const feDateRange = selectDateRange(state)
      const dateFilter = selectDateFilter(state)
      const withoutScanback = selectWithoutScanback(state)
      const companyIds = selectActualCompanyId(state)

      const params = {
        custom_dates: Array.isArray(dateFilter),
        pageSize: 10000,
        pageNumber: 1,
        emailDateRange: feDateRange,
        withoutScanback,
        company_ids: [companyIds],
        offset: getTZOffset(),
        timezone: getTimezoneId(),
        has_incident: true,
        logDateRange: null,
        classification: ['Spam', 'Unclassified'],
        email_widget_type: ['Presumed spam'],
      }

      return api.dashboard.getSpamWidget(selectedCompany, params).pipe(
        map((response) => spamWidgetRedux.onSuccess(response.response)),
        catchError((error) => of(epicsErrorHandler(spamWidgetRedux.onError, error))),
        takeUntil(action$.pipe(ofType(spamWidgetRedux.CANCEL, spamWidgetRedux.ERROR)))
      )
    })
  )

export default combineEpics(getSpamWidgetEpic)
